import { useMemo } from 'react';
import { useChgState } from './useChgState';
/**
 * Manages bool toggle state
 */
export const useToggleState = (initValue) => {
    const [state, setState] = useChgState(initValue);
    const [toggleState, toggleOn, toggleOff] = useMemo(() => [
        /* toggleState */
        () => setState((prevState) => !prevState),
        /* toggleOn */
        () => setState(true),
        /* toggleOff */
        () => setState(false),
    ], []);
    return [state, toggleState, toggleOn, toggleOff];
};
//# sourceMappingURL=useToggleState.js.map